import { dev } from './utils'

export const face1vs1 = {
  detect: ({ image }) => ({
    method: 'post',
    url: '/1vs1/detect',
    data: multiPart({ image }),
  }),

  compare: ({ image1, image2 }) => ({
    method: 'post',
    url: '/1vs1/compare',
    data: multiPart({ image1, image2 }),
  }),

  compare6n1: ({ db_image, query_image1 }) => ({
    method: 'post',
    url: '/6N1/compare',
    data: { db_image, query_image1 },
  }),

  compare122: ({ db_image, query_image1 }) => ({
    method: 'post',
    url: '/122/compare',
    data: { db_image, query_image1 },
  }),

  compare6n1zz: ({ db_image, query_image1 }) => ({
    method: 'post',
    url: '/6N1/zz/compare',
    data: { db_image, query_image1 },
  }),

  checkAlive: ({ image1 }) => ({
    method: 'post',
    url: '/1vs1/checkAlive',
    data: multiPart({ image1 })
  }),

  compareAndCheckAlive: ({ image1, image2 }) => ({
    method: 'post',
    url: '/1vs1/compareAndCheckAlive',
    data: multiPart({ image1, image2 }),
  })
}

export const face1vsV = {
  compare: ({ image, video }) => ({
    method: 'post',
    url: '/1vsV/compare',
    data: multiPart({ image, video }),
  })
}

export const bucket = {
  threshold: () => ({
    url: '/bucket/threshold',
  }),

  add: ({ name, expired }) => ({
    method: 'post',
    url: '/bucket/add',
    data: { name, expired },
  }),

  remove: ({ id }) => ({
    url: `/bucket/remove/${id}`,
  }),

  update: ({ id, name, expired }) => ({
    method: 'post',
    url: '/bucket/update',
    data: { id, name, expired },
  }),

  get: ({ id }) => ({
    url: `/bucket/${id}`
  }),

  list: () => ({
    url: '/bucket/list',
  }),

  compare: ({ bucket, image, size }) => ({
    method: 'post',
    url: '/bucket/compare',
    data: multiPart({ bucket, image, size }),
  }),

}

export const model = {
  save: ({ bucket, key, image, saveImage }) => ({
    method: 'post',
    url: '/model/save',
    data: multiPart({ bucket, key, image, saveImage }),
  }),

  remove: ({ bucket, key }) => ({
    method: 'post',
    url: '/model/remove',
    data: { bucket, key },
  }),

  list: ({ bucket, page, size }) => ({
    method: 'post',
    url: '/model/list',
    data: { bucket, page, size },
  }),

  image: ({ bucket, key }) => `${dev ? '/api' : ''}/model/image?bucket=${bucket}&key=${key}`,
}


export const record = {
  list1vs1: ({ startTime, endTime, page, size, computerNo, departmentNo, msgCode,minMatchScore,maxMatchScore }) => ({
    method: 'post',
    url: '/record/1vs1/list',
    data: { startTime, endTime, page, size, computerNo, departmentNo, msgCode: msgCode || 0 ,minMatchScore,maxMatchScore},
  }),

  statistics1vs1: ({startTime, endTime}) => ({
    method: 'post',
    url: '/record/1vs1/list/countValue',
    data: {startTime, endTime},
  }),

  list1vsV: ({ startTime, endTime, page, size, computerNo, departmentNo, msgCode }) => ({
    method: 'post',
    url: '/record/1vsV/list',
    data: { startTime, endTime, page, size, computerNo, departmentNo, msgCode: msgCode || 0 },
  }),

  statistics1vsVideo: ({startTime, endTime}) => ({
    method: 'post',
    url: '/record/1vsV/list/countValue',
    data: {startTime, endTime},
  }),

  list1vsN: ({ bucket, startTime, endTime, page, size }) => ({
    method: 'post',
    url: '/record/1vsN/list',
    data: { bucket, startTime, endTime, page, size },
  }),

  msglist: () => ({
    method: 'post',
    url: '/record/1vs1/msglist'
  }),

  image1vs1: ({ id, key }) => `${dev ? '/api' : ''}/record/1vs1/image?id=${id}&key=${key}`,

  image1vsN: ({ id }) => `${dev ? '/api' : ''}/record/1vsN/image?id=${id}`,

  image1vsV: ({ id, key }) => `${dev ? '/api' : ''}/record/1vsV/image?id=${id}&key=${key}`,

  video1vsV: ({ id, key }) => `${dev ? '/api' : ''}/record/1vsV/video?id=${id}&key=${key}`,

  compareImage1vN: ({id, key}) => `${dev ? '/api' : ''}/record/1vsN/compareImage?id=${id}&key=${key}`,
}


export const user = {
  login: ({ username, password }) => ({
    method: 'post',
    url: '/login',
    data: form({ username, password }),
  }),

  logout: () => ({
    method: 'post',
    url: '/logout',
  }),

  add: ({ username, password, name }) => ({
    method: 'post',
    url: '/user/add',
    data: { username, password, name },
  }),

  list: () => ({
    url: '/user/list'
  }),

  get: ({ id }) => ({
    url: `/user/${id}`
  }),

  exist: ({ username }) => ({
    method: 'post',
    url: '/user/exist',
    headers: {
      'Content-Type': 'text/plain; charset=utf-8'
    },
    data: username,
  }),

  update: ({ id, username, password, name }) => ({
    method: 'post',
    url: '/user/update',
    data: { id, username, password, name },
  }),

  me: () => ({
    url: '/user/me',
  }),
}

export const license = {
  check: () => ({
    method: 'post',
    url: '/License/check'
  }),
  qrcode: () => ({
    method: 'post',
    url: '/License/qrcode'
  }),
  match: ( newCode ) => ({
    method: 'post',
    url: '/License/match?newCode=' + newCode
  })
}

export const threshold = {
  get: () => ({
    url: '/bucket/threshold'
  }),
  change: ({ newThreshold }) => ({
    method: 'post',
    url: '/Config/ChangeThreshold',
    params: { newThreshold }
  })
}

export const configThreshold = {
  get: () => ({
    url: '/Config/threshold'
  }),
  update: ({ Threshold,RGBLiveThreshold,IRLiveThreshold }) => ({
    method: 'post',
    url: '/Config/threshold/update',
    data: { Threshold,RGBLiveThreshold,IRLiveThreshold }
  })
}

export const department = {
  list: () => ({
    url: '/department/list'
  }),
  get: (id) => ({
    url: '/department/' + id
  }),
  remove: (id) => ({
    url: '/department/remove/' + id
  }),
  add: ({ no, name, remark }) => ({
    method: 'post',
    url: '/department/add',
    data:{ no, name, remark }
  }),
  update: ({ id, no, name, remark }) => ({
    method: 'post',
    url: '/department/update',
    data:{ id, no, name, remark }
  }),
  query: (no) => ({
    url: '/department/query/' + no
  })
}

export const computer = {
  list: (departmentNo) => ({
    url: '/computer/list',
    params: {departmentno: departmentNo}
  }),
  get: (id) => ({
    url: '/computer/' + id
  }),
  remove: (id) => ({
    url: '/computer/remove/' + id
  }),
  add: ({ no, name, ip, departmentNo, remark }) => ({
    method: 'post',
    url: '/computer/add',
    data: { no, name, ip, departmentNo, remark }
  }),
  update: ({ id, no, name, ip, departmentNo, remark }) => ({
    method: 'post',
    url: '/computer/update',
    data:{ id, no, name, ip, departmentNo, remark }
  }),
  query: (no) => ({
    url: '/computer/query/' + no
  }),
  systemInfo:()=>({
      url:'/systeminfo'
  })
}

export const routeConfig = {
  list: () => ({
    url: '/RouteConfig/list'
  }),
  update: ({ id, route, img1CheckAlive, img2CheckAlive, compareMode }) => ({
    method: 'post',
    url: '/RouteConfig/update',
    data: { id, route, img1CheckAlive, img2CheckAlive, compareMode }
  })
}

const form = (data) => {
  if (data instanceof URLSearchParams) {
    return data
  }
  let form = new URLSearchParams()
  for (let [k, v] of Object.entries(data)) {
    form.append(k, v)
    console.log(k, v, form)
  }
  return form
}


const multiPart = (data) => {
  if (data instanceof FormData) {
    return data
  }
  let form = new FormData()
  for (let [k, v] of Object.entries(data)) {
    form.append(k, v)
  }
  return form
}
